import React from 'react';
import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { OrderInfo } from 'common/types';
import { RiMapPinLine } from 'react-icons/ri';
import { RentalsTabValue, RentalsTabValues } from 'services/types';

interface Props {
	rentalInfo: OrderInfo;
	rentalTab: RentalsTabValue;
	showLocations: boolean;
}
const RentalCardLocations = (props: Props) => {
	const classes = useStyles();
	const { rentalInfo, rentalTab } = props;

	const isDifferentLocations = () => {
		const start = rentalInfo.startLocation;
		const end = rentalInfo.endLocation;
		if (start.id && end.id && start.id !== end.id) {
			return true;
		}
		if ((!start.id || !end.id) && start.name && end.name && start.name !== end.name) {
			return true;
		}
		if ((!start.id || !end.id) && (!start.name || !end.name) && start.address !== end.address) {
			return true;
		}
		return false;
	};

	return (
		<div className={classes.location}>
			<RiMapPinLine className={classes.locationIcon} />
			<div>
				{rentalTab === RentalsTabValues.COMPLETED ? (
					isDifferentLocations() ? (
						<Typography variant="caption">
							{rentalInfo.startLocation.name || rentalInfo.startLocation.address}
							{' - '}
							{rentalInfo.endLocation.name || rentalInfo.endLocation.address}
						</Typography>
					) : (
						<Typography variant="caption">
							{rentalInfo.startLocation.name || rentalInfo.startLocation.address}
						</Typography>
					)
				) : isDifferentLocations() ? (
					<Typography variant="caption">
						{rentalInfo.startLocation.name || rentalInfo.startLocation.address}
						{' - '}
						{rentalInfo.endLocation.name || rentalInfo.endLocation.address}
					</Typography>
				) : rentalTab === RentalsTabValues.ACTIVE ? (
					<Typography variant="caption">
						{rentalInfo.endLocation.name || rentalInfo.endLocation.address}
					</Typography>
				) : (
					<Typography variant="caption">
						{rentalInfo.startLocation.name || rentalInfo.startLocation.address}
					</Typography>
				)}
			</div>
		</div>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		locationIcon: {
			fontSize: '1.4rem',
			marginRight: 4,
			marginBottom: 2,
		},
		location: {
			display: 'flex',
			marginTop: theme.spacing(2),
			marginBottom: -theme.spacing(2),
			alignItems: 'center',
		},
	}),
);

export default RentalCardLocations;
